function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#bdbfc3",
  d: "M13.138 5.3c0 1.631-1.36 2.99-2.99 2.99-1.686 0-3.045-1.359-3.045-2.99a3.04 3.04 0 0 1 3.045-3.044c1.63 0 2.99 1.36 2.99 3.044zm-7.666 0c0 1.631.87 3.1 2.175 3.915a8.948 8.948 0 0 0-6.361 7.502c-.109.979 1.522 1.033 1.63.163a7.247 7.247 0 0 1 7.232-6.415c3.696 0 6.74 2.773 7.176 6.415.109.87 1.74.816 1.63-.163-.38-3.588-2.935-6.524-6.306-7.502a4.717 4.717 0 0 0 2.12-3.915c0-2.61-2.065-4.675-4.62-4.675A4.64 4.64 0 0 0 5.472 5.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#bdbfc3",
  strokeMiterlimit: 20,
  strokeWidth: 0.5,
  d: "M13.138 5.3c0 1.631-1.36 2.99-2.99 2.99-1.686 0-3.045-1.359-3.045-2.99a3.04 3.04 0 0 1 3.045-3.044c1.63 0 2.99 1.36 2.99 3.044zm-7.666 0c0 1.631.87 3.1 2.175 3.915a8.948 8.948 0 0 0-6.361 7.502c-.109.979 1.522 1.033 1.63.163a7.247 7.247 0 0 1 7.232-6.415c3.696 0 6.74 2.773 7.176 6.415.109.87 1.74.816 1.63-.163-.38-3.588-2.935-6.524-6.306-7.502a4.717 4.717 0 0 0 2.12-3.915c0-2.61-2.065-4.675-4.62-4.675A4.64 4.64 0 0 0 5.472 5.3z"
})));

var SvgInviteIndividualLogo = function SvgInviteIndividualLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInviteIndividualLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/invite-individual-logo.ec845f2a.svg";
export { ForwardRef as ReactComponent };